import React from "react";

function CounterSection() {
  const counters = [
    {
      icon: "far fa-users",
      number: "25k+",
      label: "Active Students",
    },
    {
      icon: "far fa-book-open",
      number: "1.2k+",
      label: "Total Courses",
    },
    {
      icon: "far fa-chalkboard-teacher",
      number: "600+",
      label: "Expert Instructors",
    },
    {
      icon: "far fa-award",
      number: "150+",
      label: "Awards Won",
    },
  ];

  return (
    <div className="counter-area py-100">
      <div className="container">
        <div className="row g-4 text-center">

          {counters.map((item, index) => (
            <div className="col-md-3 col-6" key={index}>
              <div
                className="counter-box wow fadeInUp"
                data-wow-delay={`.${index}s`}
              >
                <div className="counter-icon">
                  <i className={item.icon}></i>
                </div>

                <h3 className="counter-number">{item.number}</h3>
                <p className="counter-label">{item.label}</p>
              </div>
            </div>
          ))}

        </div>
      </div>
    </div>
  );
}

export default CounterSection;
